"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicRoutes = exports.Authorisations = void 0;
exports.Authorisations = [
    {
        field: "dashboard",
        label: "Tableau de bord"
    },
    {
        field: "api-orm-metrics",
        label: "ORM Dashboard"
    },
    {
        field: "socket-io",
        label: "Socket IO"
    },
    {
        field: "administrateurs",
        label: "Administrateurs"
    },
    {
        field: "categories",
        label: "Categories"
    },
    {
        field: "directions",
        label: "Directions"
    },
    {
        field: "entres-sorties-autoroute",
        label: "Entres et sorties autoroute"
    },
    {
        field: "espaces",
        label: "Espaces"
    },
    {
        field: "messages",
        label: "Messages"
    },
    {
        field: "notifications",
        label: "Notifications"
    },
    {
        field: "options",
        label: "Options"
    },
    {
        field: "rapidos",
        label: "Rapidos"
    },
    {
        field: "sos-remorquages",
        label: "SOS Remorquages"
    },
    {
        field: "suggestions-remarques",
        label: "Suggestions et remarques"
    },
    {
        field: "tarifs",
        label: "Tarifs"
    },
    {
        field: "toll-points",
        label: "Toll points"
    },
    {
        field: "transactions",
        label: "Transactions"
    },
    {
        field: "utilisateurs",
        label: "Utilisateurs"
    },
    {
        field: "vehicle-types",
        label: "Types de véhicule"
    },
    {
        field: "parametres",
        label: "Paramètres"
    },
];
exports.publicRoutes = [
    '/double-authentification/:userId',
    '/',
];
